module.exports = __webpack_public_path__ + "static/media/mandala.dcaa54bc.svg";